import type {
  StructuredAnalysis,
  StructuredAnalysisBody,
} from "@/schemas/structured-analysis.schema";
import type { RequestConfig } from "@/services/api";
import { api } from "@/services/api";

export const structuredAnalysisApi = {
  async create(
    body: StructuredAnalysisBody,
    config?: RequestConfig
  ): Promise<StructuredAnalysis> {
    const { data } = await api.post<StructuredAnalysis>("/structured-analyses", body, config);
    return data;
  },

  async updateById(id: string, body: Partial<StructuredAnalysisBody>, config?: RequestConfig) {
    await api.patch(`/structured-analyses/${id}`, body, config);
  },

  async deleteById(id: string, config?: RequestConfig) {
    await api.delete(`/structured-analyses/${id}`, config);
  },

  async execute(id: string, content: string) {
    const { data } = await api.post<{ result: string }>(`/structured-analyses/${id}/execute`, {
      content,
    });

    return data.result;
  },
};
